<div class="jumbotron mb-3">
  <h1 class="jumbotron-headline" i18n="404 page not found headline|404 page not found headline">Page not found</h1>
  <p class="jumbotron-lead" i18n="404 page not found lead text|404 page not found lead text">The requested page <b>{{currentUrl}}</b> was not found. Error 404.
  </p>
  <p class="jumbotron-lead">
    <app-mat-icon-button [routerLink]="['/']" i18n-label="button Go to start page|button Go to start page" label="Go to start page"></app-mat-icon-button>
  </p>
</div>
